/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Image } from 'react-bootstrap';

import { tab_commandes, tab_modeles, tab_couleurs, images_links } from '../Correspondances';

function DisplayImage({store_type, couleur, commande, isPortrait}) {
	let src_img, width_s;
	if (store_type === 0)
		src_img = tab_modeles[store_type] + "_" + tab_couleurs[couleur] + "_" + tab_commandes[commande] + "_Indoor";
	else
		src_img = tab_modeles[store_type] + "_Blanc_" + tab_commandes[commande] + "_Indoor";

	isPortrait ? width_s = "150px" : width_s = "380px";

	return (
		<Image src={images_links[src_img]} style={{ width: width_s }} rounded className='img_preview' alt='preview-image'/>
	);
}

export default DisplayImage;
